"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieUtil = void 0;
const common_types_1 = require("@as-react/common-types");
class CookieUtil {
    static get(key) {
        const keyEQ = `${key}=`;
        const cookieArray = document.cookie.split('; ');
        const cookie = cookieArray.find((cookieArrayItem) => cookieArrayItem.indexOf(keyEQ) === 0);
        return cookie ? cookie.substring(keyEQ.length) : null;
    }
    static getByRegexp(key) {
        const cookieArray = document.cookie.split('; ');
        const findCookie = cookieArray.find(el => key.test(el));
        const matchedCookie = findCookie && key.exec(findCookie);
        return matchedCookie ? this.get(matchedCookie[0]) : null;
    }
    static set(key, value = '', options = {}) {
        const { timeInMs, secure } = options;
        let expires = ' ';
        if (timeInMs) {
            const date = new Date();
            date.setTime(date.getTime() + timeInMs);
            expires = ` expires=${date.toUTCString()}; `;
        }
        document.cookie = `${key}=${value};${expires}${secure ? 'secure; ' : ''}path=/`;
        this.fireChange(key, value);
    }
    static delete(key) {
        document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
        this.fireChange(key, null);
    }
    static addChangeListener(key, callback) {
        this.callbackQueue.push({
            key,
            callback,
        });
    }
    static removeChangeListener(key, callback) {
        this.callbackQueue = this.callbackQueue.filter((item) => {
            return !(item.key === key && item.callback === callback);
        });
    }
    static isCookieLevelAcceptAll() {
        return this.isCookieLevel(common_types_1.CookieLevel.LEVEL_TWO);
    }
    static getFredhopperSegment() {
        const fredhopperSegment = this.get(common_types_1.Cookie.FREDHOPPER_SEGMENT);
        if (fredhopperSegment) {
            return this.get(common_types_1.Cookie.FREDHOPPER_SEGMENT);
        }
        else {
            return common_types_1.FredhopperSegment.A; // Todo: needed ?
        }
    }
    static fireChange(key, value) {
        this.callbackQueue.forEach((item) => {
            if (item.key === key) {
                item.callback(value);
            }
        });
    }
    static getCookieLevel() {
        return Number(this.get(common_types_1.Cookie.LEVEL));
    }
    static isCookieLevel(level) {
        return this.getCookieLevel() === level;
    }
}
exports.CookieUtil = CookieUtil;
CookieUtil.callbackQueue = [];
//# sourceMappingURL=CookieUtil.js.map